import React from 'react';

const Overlay = ({ loading, paymentMethod }) => {
	if (paymentMethod === 'paypal') {
		return (
			<div
				className={`${
					loading ? 'screen-overlay--loadingPaypal screen-overlay' : 'screen-overlay--blur screen-overlay'
				}`}
			>
				{loading && (
					<div className="spinner" style={{ position: 'absolute' }}>
						<div className="spin">
							<div></div>
						</div>
					</div>
				)}
			</div>
		);
	}
	if (paymentMethod === 'card') {
		return (
			<div
				className={`${
					loading ? 'screen-overlay screen-overlay--loadingCreditCard' : 'screen-overlay--blur screen-overlay'
				}`}
			></div>
		);
	}
};

export default Overlay;
